import React from 'preact/compat';
import { h } from 'preact';
import Checkbox, { CheckboxProps } from '@ingka/checkbox';
import { PREFIX } from 'list/DesignSystem/constants';
import './checkbox.scss';

// @ts-ignore
export default (props: CheckboxProps) => <Checkbox prefix={PREFIX} {...props} />;
